import {
  AddContentFavoriteAction,
  ContentFavoriteAddedAction,
  ContentFavoriteRemovedAction,
  RemoveContentFavoriteAction,
  SearchActionTypes,
} from './ActionTypes';
import { SearchResultItem } from '../models/SearchResultTypes';

export function addContentFavorite(item: SearchResultItem): AddContentFavoriteAction {
  return {
    type: SearchActionTypes.ADD_CONTENT_FAVORITE_ACTION,
    item: item,
  };
}

export function contentFavoriteAdded(item: SearchResultItem): ContentFavoriteAddedAction {
  return {
    type: SearchActionTypes.CONTENT_FAVORITE_ADDED_ACTION,
    item: item,
  };
}

export function removeContentFavorite(item: SearchResultItem): RemoveContentFavoriteAction {
  return {
    type: SearchActionTypes.REMOVE_CONTENT_FAVORITE_ACTION,
    item: item,
  };
}

export function contentFavoriteRemoved(item: SearchResultItem): ContentFavoriteRemovedAction {
  return {
    type: SearchActionTypes.CONTENT_FAVORITE_REMOVED_ACTION,
    item: item,
  };
}
